// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content{position:fixed;top:50px;bottom:0;width:100%;overflow:auto}.content .bp4-tabs{margin-left:16px}", ""]);
// Exports
module.exports = exports;
